import { useMediaQuery } from "./useMediaQuery";

/**
 * The media query for "the primary pointer is coarse" - a finger rather than a
 * mouse or trackpad. Exported so tests can seed the same string the hook asks
 * for.
 */
export const COARSE_POINTER_QUERY = "(pointer: coarse)";

/**
 * Whether the device's primary input is touch.
 *
 * Deliberately a *pointer* query rather than a width one: the two don't line up.
 * An iPad is `md`/`lg` wide and entirely touch-driven, while a small laptop
 * window is narrow and still has a trackpad. Anything that exists because a
 * finger is imprecise (bigger hit areas) or because a physical keyboard is
 * absent (arrow-key hints) has to branch on the pointer, or it will be wrong on
 * a tablet in exactly the way this epic is trying to fix.
 *
 * `(pointer: coarse)` reports the *primary* pointer, so a touchscreen laptop
 * driven by its trackpad reads as fine - which is the right answer for both
 * uses above. A touch-capability probe (`ontouchstart`, `maxTouchPoints`) would
 * not be: it is true for that laptop, and it is a one-shot check that cannot
 * re-render when a tablet is docked to a mouse.
 */
export function useIsTouch(): boolean {
  return useMediaQuery(COARSE_POINTER_QUERY);
}
